export const numbersRegex = /^\d+$/;
